import type { z } from 'zod';

import { getAppAdvancedSearchFormSchema } from '../../../../../../components/AppAdvancedSearch/helpers/getAppAdvancedSearchFormSchema';

// Schema for client filters (moved from main search to filter)
export const advisorClientAccessFilterFormSchema =
	getAppAdvancedSearchFormSchema({
		alphabetErrorText: '',
		numberErrorText: '',
		emailErrorText: '',
		atLeastOneFieldMustBeFilledInText: '',
		noSlashText: '',
		dateMustBeAfterOrEqualMinText: '',
		dateMustBeBeforeOrEqualTodayText: '',
		getMaxStringLengthText: () => '',
		getBirthNumberRemainderText: () => '',
		birthNumberInvalidText: '',
		getBirthNumberLengthText: () => '',
		getPhoneLengthError: () => '',
	});

export type AdvisorClientAccessFilterForm = z.infer<
	typeof advisorClientAccessFilterFormSchema
>;
